export const RECENT_ANSWER_LIMIT = 100;
export const DEFAULT_EXTRA_SLOTS = 2;
/** Ten selections per block. Extra slots never touch, including across blocks. */
export function shuffledPoolBlock(previous, extraSlots = DEFAULT_EXTRA_SLOTS, random = Math.random) {
    if (!Number.isInteger(extraSlots) || extraSlots < 0 || extraSlots > 4) {
        throw new RangeError("extraSlots must be between 0 and 4");
    }
    const block = Array(10).fill("base");
    const placements = [];
    const build = (chosen, start) => {
        if (chosen.length === extraSlots) {
            placements.push(chosen);
            return;
        }
        for (let i = start; i < 10; i += 1) {
            if (i === 0 && previous === "extra")
                continue;
            build([...chosen, i], i + 2);
        }
    };
    build([], 0);
    const selected = placements[Math.floor(random() * placements.length)];
    for (const index of selected)
        block[index] = "extra";
    return block;
}
/** Selects a word while progressively relaxing only the oldest history. */
export function chooseAnswer(pools, requested, recentNewestFirst, usedInMatch, random = Math.random, strictPool = false, minimumRemaining = 1) {
    const other = requested === "base" ? "extra" : "base";
    const recent = recentNewestFirst;
    for (let keep = recent.length; keep >= 0; keep -= 1) {
        const excluded = new Set(recent.slice(0, keep));
        for (const pool of strictPool ? [requested] : [requested, other]) {
            const candidates = pools[pool].filter((word) => !usedInMatch.has(word) && !excluded.has(word));
            if (candidates.length >= minimumRemaining) {
                return { answer: candidates[Math.floor(random() * candidates.length)], pool, relaxed: recent.length - keep };
            }
        }
    }
    throw new Error("No unused answer remains in either pool");
}
//# sourceMappingURL=wordSelection.js.map